import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// Helpers
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2a2738', // #E53935
        secondary: '#776F9B', // #FFCDD2
        accent: colors.yellow.darken3 // #3F51B5
      }
    }
  }
})
